import styled from "styled-components";
import { Flex } from "antd";

const StyledContainer = styled(Flex)`
  background: ${({ token }) => token.page_dashboard__background};
  min-width: 1024px;
  overflow: auto;
  position: relative;

  &::before {
    content: "";
    background: ${({ token }) => token.page_dashboard__hero_background};
    background-size: cover;
    height: 500px;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    z-index: 0;
  }

  .container-proposals {
    position: relative;
  }

  h4 {
    color: #9d9d9d;
    font-size: 18px;
    font-weight: 400;
    margin: unset;
  }

  .container-cards {
    padding: 32px;
    position: relative;

    h3 {
      border-bottom: 1px solid rgba(218, 222, 229, 0.3);
      color: #fff;
      font-size: 19px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      margin: 0;
      padding: 7px 0;
    }
  }

  .container-content {
    margin: 0 auto;
    width: 874px;
  }
`;

export default StyledContainer;
